import { GeneralError } from './base';
import { typeMap as errorTypeMap } from './type-map';

export default class extends GeneralError {
  constructor(payload) {
    super(errorTypeMap.internal, payload);
  }
}
